import React, { useEffect } from 'react';
import Panel from '@/components/Panel';
import QuestionList from '@/components/QuestionList';
import { getHotList } from '@/utils/getData';
import { useTranslation } from 'react-i18next';
import { helpCenterTracking } from '@/utils/track';

const DEFAULT_HOT_LIST_NUM = 10;
const HOT_LIST_SHOW = getHotList().slice(0, DEFAULT_HOT_LIST_NUM);

const HotQuestion: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    // 动态设置title，需要客户端提供bridge
    document.title = t('faq_full');
  }, [t]);

  useEffect(() => {
    helpCenterTracking({
      operation: 'view',
      page: 'help_centre_all_faqs',
    });
  }, []);

  return (
    <Panel>
      <QuestionList
        list={HOT_LIST_SHOW}
        onTrack={(item, index) =>
          helpCenterTracking({
            operation: 'click',
            target: 'article',
            page: 'help_centre_all_faqs',
            data: {
              article_url: `${window.location.origin}/help-center/details/${item.fileName}`,
            },
          })
        }
      />
    </Panel>
  );
};

export default HotQuestion;
